<sb-card [isCollapsed]="false" [collapsedCard]="true">
  <div card-header classes="no-border w-100" class="d-flex flex-row align-items-center w-100">
    <div>
      <h3>
        Selected Areas
      </h3>
      <small></small>
    </div>
  </div>
  <div card-header-more>
    <div class="flex-row d-flex">

    </div>
  </div>
  <div card-body>
    <div class="flex-row d-flex mydropdown">
      <ng-scrollbar [style.height.px]="259">
        <button *ngFor="let result of areas" ngbTooltip [sbMapTooltip]="{type: 'AreaDTO', data: [result]}"
                container="body" tooltipClass="widthFix" placement="right left" class="dropdown-item cursor-pointer"
                [ngClass]="getClass()" type="button" (click)="toggle(result)">
          {{getName(result)}}&nbsp;
          <br>
          <div style="font-size: smaller;">
            {{getDescription(result)}}&nbsp;
          </div>
        </button>
      </ng-scrollbar>
    </div>
    <br>
    <div class="flex-row d-flex">
      <div class="d-flex align-items-center justify-content-between">
        <div class="pagination__options">
          <span class="mr-2">{{areas?.length}} Areas selected</span>
        </div>
      </div>
    </div>

  </div>
</sb-card>
